import { IFilter } from '@wyz/types';
import { isNil } from 'lodash-es';
const sanitizeValue = (value: unknown) => {
  if (Array.isArray(value)) {
    return value.filter((val) => val !== '' && !isNil(val));
  }
  return value === '' ? undefined : value;
};
export const getConditionValue = (
  conditions: IFilter['conditions'],
  field: string,
): IFilter['conditions'][0] | undefined => {
  const condition = conditions.find((c) => c.column === field);

  return condition
    ? {
        ...condition,
        value: sanitizeValue(condition.value),
      }
    : undefined;
};
